// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/static/ContactForm.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
var _s = $RefreshSig$();
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/static/ContactForm.tsx");
  import.meta.hot.lastModified = "1740183864616.5415";
}
// REMIX HMR END

import { schema } from "~/routes/resources.request";
import Form from "~/components/forms/Form";
import { useFetcher } from "@remix-run/react";
import { Fragment, useEffect, useState } from "react";
import { HoneypotInputs } from "remix-utils/honeypot/react";
import Button from "~/components/Button";
import IconResolver from "~/components/IconResolver";
import ContentWrapper from "~/components/ContentWrapper";
import Heading from "../Heading";
const Errors = {
  EMAIL_REGISTERED: <Fragment>
      <p className="font-bold">We’ve already received your request.</p>
      <p>We’ll contact you as soon as possible.</p>
    </Fragment>,
  UNEXPECTED_ERROR: <Fragment>
      <p className="font-bold">Sorry, we couldn't send your request.</p>
      <p>Please try again or contact hq@octahedroid.com</p>
    </Fragment>
};
export default function ContactForm() {
  _s();
  const fetcher = useFetcher();
  const [showForm, setShowForm] = useState(true);
  useEffect(() => {
    if (fetcher.state === "loading" && fetcher.data?.success) {
      setShowForm(false);
    }
  }, [fetcher.state, fetcher.data?.success]);
  return <ContentWrapper spacing="primary" className="children:!max-w-lg">
      <section className="flex flex-col items-center w-full">
        {showForm ? <Fragment>
            <Heading tag="h2" id="how-can-we-help-you">
              How can we help you?
            </Heading>
            <p className="text-neutral-600 mb-4">
              We will contact you promptly to discuss next steps.
            </p>
            <Form id="requestDemoForm" action="/resources/request" buttonLabel="Submit" fetcher={fetcher} mode="onBlur" className="space-y-4 w-full flex flex-col items-center children:w-full" schema={schema} options={{
          interestedIn: [{
            name: "I’m interested in",
            value: "I’m interested in"
          }, {
            name: "Decoupled Architectures",
            value: "Decoupled Architectures"
          }, {
            name: "Custom Web App Development",
            value: "Custom Web App Development"
          }, {
            name: "Drupal Digital Experiences",
            value: "Drupal Digital Experiences"
          }, {
            name: "Quality Assurance (QA)",
            value: "Quality Assurance (QA)"
          }, {
            name: "Web Accessibility",
            value: "Web Accessibility"
          }, {
            name: "Audit SEO & Performance",
            value: "Audit SEO & Performance"
          }, {
            name: "DevOps",
            value: "DevOps"
          }, {
            name: "E-commerce",
            value: "E-commerce"
          }, {
            name: "Other",
            value: "Other"
          }]
        }} multiline={["comments"]}>
              {({
            Field,
            Button
          }) => <Fragment>
                  <HoneypotInputs label="Please leave this field blank" />
                  <Field name="name" label="Name" />
                  <Field name="email" label="Email" />
                  <Field name="companyName" label="Company" />
                  <Field name="interestedIn" />
                  <Field name="comments" label="Message" />
                  {fetcher.data?.errors?._global && <div className="mt-4 text-center bg-error-600 p-4 text-white">
                      {Errors[fetcher.data?.errors?._global]}
                    </div>}
                  <Button className="!w-fit justify-self-end ml-auto">
                    Submit
                  </Button>
                </Fragment>}
            </Form>
          </Fragment> : <Fragment>
            <div className="mb-4 relative w-10 h-12">
              <img src="/assets/logo/icon_plain.svg" alt="Octahedroid Logo" aria-hidden="true" className="absolute opacity-100 transition-opacity duration-300 hover:opacity-0" />
              <img src="/assets/logo/icon_hover.svg" alt="Octahedroid Logo" aria-hidden="true" className="absolute opacity-0 hover:opacity-100 transition-opacity duration-300" />
            </div>
            <Heading tag="h2">Thank you</Heading>
            <p className="text-neutral-600 mb-4 text-center">
              We've received your message.
              <br /> We'll contact you soon!
            </p>
            <Button className="flex items-center" variant="secondary" type="button" onClick={() => setShowForm(true)}>
              <Fragment>
                <IconResolver className="w-5 h-5 mr-4" token="arrow-narrow-left" />
                Back
              </Fragment>
            </Button>
          </Fragment>}
      </section>
    </ContentWrapper>;
}
_s(ContactForm, "EEXEzp8Q+CIaH8McyxlKNRg8DX0=", false, function () {
  return [useFetcher];
});
_c = ContactForm;
var _c;
$RefreshReg$(_c, "ContactForm");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;